import httpClient from 'api/httpClient';
import { LeadNotification } from 'models/LeadNotifications';
import { PaginatedData, PaginationParams } from 'models/PaginatedData';

function getNotifications(
  params: PaginationParams & {
    channel?: string;
  },
) {
  return httpClient.get<PaginatedData<LeadNotification>>(
    '/lead-notifications',
    {
      params,
    },
  );
}

function getLeads(params: PaginationParams) {
  return httpClient.get<{ name: string; buyerId: string }[]>(
    '/lead-notifications/filter/leads',
    {
      params,
    },
  );
}

function getDeals(params: PaginationParams) {
  return httpClient.get<{ name: string; dealRoomId: string }[]>(
    '/lead-notifications/filter/deal-rooms',
    {
      params,
    },
  );
}

export default {
  getNotifications,
  getLeads,
  getDeals,
};
